/* eslint-disable no-useless-escape */
// TODO remove this line (it's for EMAIL_PATTERN) and write a test to make sure it works without the escape chars
export const ValidationRegex = {
  // Source: http://emailregex.com/
  EMAIL_PATTERN: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // Source: http://regexlib.com/REDetails.aspx?regexp_id=22
  PHONE_NUMBER_PATTERN: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
  NAME_REGEX: /^[a-zA-ZÀ-ÿ0-9-_\s]*$/,
  CANADIAN_POSTAL_CODE_REGEX: /^( *)[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]( *)$/,
  US_POSTAL_CODE_REGEX: /^( *)[0-9]{5}(?:-[0-9]{4})?( *)$/,
  CURRENCY_REGEX: /^\$?(?=\(.*\)|[^()]*$)\(?\d{1,3}(,\d\d?)?(\.\d\d?)?\)?$/,
  BIRTHDAY_REGEX: /^(0[13578]|1[02])\/(0[1-9]|[12][0-9]|3[01])|(0[469]|11)\/(0[1-9]|[12][0-9]|30)|02\/(0[1-9]|[12][0-9])$/,
  STORE_CODE: /\d{4}/,
  COORDINATE: /^-?[0-9]{1,3}(?:\.[0-9]{1,20})?$/,
  ONE_DIGIT_AND_LETTER: /^(?=.*[a-zA-Z])(?=.*[0-9])/,
  ALPHANUMERIC_DASH: /^[a-zA-Z0-9-]*$/,
  EMAIL_LIST: /[ ;,`"&|()<>{}\[\]\r\n/\\]+/,
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/validator/validation-regex.ts